import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { get } from "lodash";

import "./FitnessHome.scss";
import MyHistoryGraph from "../myHistory/myHistoryGraph";
import PotentialBurn from "../exercise/potentialBurn";
import PlaceholderIMG from "../../../sharedComponents/placeholderImage";
import { getAds } from "../../../store/actions";
import AdCarousel from "../../home/adCarousel";
import { headerData } from "./helper";

const FitnessHome = ({ ads, getAds }) => {
	useEffect(() => {
		getAds();
	}, [getAds]);

	return (
		<div className="container">
			<div className="row mt-4">
				{headerData &&
					headerData.map((item, index) => (
						<div key={index} className="col-4 flex-fill">
							<div className="card card-primary p-4 rounded-lg border-0 card-shadow h-100">
								<div className="d-flex flex-row">
									<div className="col-4 p-0">
										<PlaceholderIMG
											src={item.image}
											alt={item.title}
											width="120"
											height="70"
											objectFit="contain"
										/>
									</div>
									<div className="col-8">
										<h4>{item.title}</h4>
										<p className="mb-0">{item.content}</p>
										<Link to={item.link.to} className="text-primary-dark font-weight-bolder">
											{item.link.text} <i className="icon icon-caret-right xs-icon" />
										</Link>
									</div>
								</div>
							</div>
						</div>
					))}
			</div>

			<div className="row mt-4">
				<div className="col-8 h-100">
					<div className="card card-primary p-2 rounded-lg border-0">
						<MyHistoryGraph title={"Track My Results"} />
					</div>
				</div>
				<div className="col-4 h-100">
					<div className="mb-3">
						<AdCarousel ads={ads} height="250px" />
					</div>
					<PotentialBurn exercise={{ id: 1078 }} />
				</div>
			</div>
		</div>
	);
};

const mapDispatchToProps = {
	getAds
};

const mapStateToProps = (state) => {
	const { Home } = state;
	return {
		ads: get(Home, "ads", [])
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FitnessHome);
